import type { Pet, PetAttribute, PetStatusEffect } from '.';
import { createMessage, createMessages, SB } from '@play-co/replicant';

export const petMessages = (
  Pet: Pet,
  { PetStats, Fate }: Pet['$DEPENDENCIES'],
) =>
  createMessages(
    SB.object({ ...Pet.schema, ...PetStats.schema, ...Fate.schema }),
  )({
    /**
     * Change friend pet fate by applying status effects and attributes
     */
    updateFate: createMessage(
      SB.object({
        effects: SB.object(
          Pet.ruleset.petStatusEffects.reduce(
            (acc, cur) => ({ ...acc, [cur]: SB.boolean().optional() }),
            {},
          ),
        ),
        attributes: SB.object(
          Pet.ruleset.petAttributes.reduce(
            (acc, cur) => ({ ...acc, [cur]: SB.number().optional() }),
            {},
          ),
        ),
        now: SB.int(),
      }),
      (state, args) => {
        Object.keys(args.effects).forEach((key) => {
          const statusEffect = key as PetStatusEffect;
          const { resolveStatusEffect } = Fate.api;
          resolveStatusEffect(
            (state as unknown) as any,
            statusEffect,
            args.effects[statusEffect],
            args.now,
          );
        });
        Object.keys(args.attributes).forEach((key) => {
          const attribute = key as PetAttribute;
          const { setAttribute } = PetStats.modifiers;
          const { getAttributeValue } = Pet.getters(
            (state as unknown) as Pet.State,
          );
          setAttribute(
            state,
            attribute,
            getAttributeValue(attribute, args.now) + args.attributes[attribute],
            args.now,
          );
        });
        Fate.api.update((state as unknown) as any, args.now);
      },
    ),

    updateStatusEffects: createMessage(
      SB.object(
        Pet.ruleset.petStatusEffects.reduce(
          (acc, cur) => ({ ...acc, [cur]: SB.boolean().optional() }),
          {},
        ),
      ),
      (state, args, { timestamp }) => {
        Object.keys(args).forEach((key) => {
          const statusEffect = key as PetStatusEffect;
          const { resolveStatusEffect } = Fate.api;

          resolveStatusEffect(
            (state as unknown) as any,
            statusEffect,
            args[statusEffect],
            timestamp,
          );
        });
        Fate.api.update((state as unknown) as any, timestamp);
      },
    ),

    updateAttributes: createMessage(
      SB.object(
        Pet.ruleset.petAttributes.reduce(
          (acc, cur) => ({ ...acc, [cur]: SB.number().optional() }),
          {},
        ),
      ),
      (state, args, { timestamp }) => {
        Object.keys(args).forEach((key) => {
          const attribute = key as PetAttribute;

          const { setAttribute } = PetStats.modifiers;
          const { getAttributeValue } = Pet.getters(
            (state as unknown) as Pet.State,
          );

          setAttribute(
            state,
            attribute,
            getAttributeValue(attribute, timestamp) + args[attribute],
            timestamp,
          );
        });
        Fate.api.update((state as unknown) as any, timestamp);
      },
    ),
  });
